import { Input } from "@/components/ui/input";
import { ChecklistPhotos } from "@/components/movein/ChecklistPhotos";
import { CONDITIONS } from "@/components/movein/ChecklistItem";
import { cn } from "@/lib/utils";

export const COND_BADGE = {
  good: "bg-emerald-100 text-emerald-800", fair: "bg-amber-100 text-amber-800", poor: "bg-rose-100 text-rose-800", na: "bg-slate-100 text-slate-600",
};
export const condLabel = (c) => (CONDITIONS.find((x) => x.key === c)?.label || "—");

export function CondBadge({ c, testid }) {
  return <span className={cn("inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold", COND_BADGE[c] || "bg-slate-50 text-slate-400")} data-testid={testid}>{condLabel(c)}</span>;
}

export function MoveOutItemRow({ inspectionId, tenantId, roomKey, item, onPatch, onPhotosChange }) {
  const id = `${roomKey}-${item.key}`;
  const mi = item.move_in;
  const paths = {
    upload: (r, i) => `/tenants/${tenantId}/move-out/items/${r}/${i}/photos`,
    view: (pid) => `/move-out/${inspectionId}/photos/${pid}`,
    remove: (pid) => `/tenants/${tenantId}/move-out/photos/${pid}`,
  };
  return (
    <div className={cn("py-3.5 border-b border-slate-100 last:border-0", !item.condition && "bg-amber-50/40 -mx-2 px-2 rounded-lg")} data-testid={`moveout-item-${id}`}>
      <div className="grid md:grid-cols-[1fr_auto] gap-3 items-start">
        <div>
          <div className="text-sm font-semibold text-slate-800">{item.label}</div>
          <div className="flex flex-wrap items-center gap-2 mt-1 text-xs text-slate-500">
            <span>Move-in:</span><CondBadge c={mi?.condition} testid={`moveout-movein-cond-${id}`} />
            {mi?.note && <span className="italic truncate max-w-[280px]">“{mi.note}”</span>}
            {mi?.photos?.length > 0 && <span>· {mi.photos.length} photo(s)</span>}
            {!mi && <span className="text-slate-400">no move-in record</span>}
          </div>
        </div>
        <div className="flex gap-1.5" role="radiogroup" aria-label={`${item.label} move-out condition`}>
          {CONDITIONS.map((c) => {
            const active = item.condition === c.key;
            return (
              <button key={c.key} type="button" role="radio" aria-checked={active} onClick={() => onPatch({ condition: active ? null : c.key })}
                data-testid={`moveout-cond-${id}-${c.key}`}
                className={cn("rounded-full border px-3 py-1 text-xs font-semibold transition-colors", active ? c.on : c.off)}>{c.label}</button>
            );
          })}
        </div>
      </div>
      <div className="grid sm:grid-cols-[1fr_150px] gap-2 mt-2">
        <Input value={item.note || ""} onChange={(e) => onPatch({ note: e.target.value })} maxLength={500} placeholder="Move-out notes — damage beyond normal wear…" className="h-9 text-sm" data-testid={`moveout-note-${id}`} />
        <div className="relative">
          <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400">$</span>
          <Input type="number" min={0} value={item.deduction ?? 0} onChange={(e) => onPatch({ deduction: e.target.value })} className="h-9 pl-6 text-sm font-mono" placeholder="0" data-testid={`moveout-deduction-${id}`} title="Deduction from deposit" />
        </div>
      </div>
      <ChecklistPhotos checklistId={inspectionId} roomKey={roomKey} item={item} locked={false} onChange={onPhotosChange} paths={paths} />
    </div>
  );
}
